import type { RealtimeMode } from "../../types/traffic";

const orderedModes: Exclude<RealtimeMode, "mock">[] = [
  "full",
  "reduced",
  "aggregate",
  "offline",
];

export function modeAfterRealtimeFailures(
  current: Exclude<RealtimeMode, "mock">,
  consecutiveFailures: number,
): Exclude<RealtimeMode, "mock"> {
  if (consecutiveFailures < 2) return current;
  const index = orderedModes.indexOf(current);
  return (
    orderedModes[Math.min(orderedModes.length - 1, index + 1)] ?? "offline"
  );
}

export function modeCapabilities(mode: RealtimeMode): {
  presence: boolean;
  interactions: boolean;
  heartbeatMultiplier: number;
  eventThrottleMs: number;
} {
  switch (mode) {
    case "mock":
    case "full":
      return {
        presence: true,
        interactions: true,
        heartbeatMultiplier: 1,
        eventThrottleMs: 0,
      };
    case "reduced":
      return {
        presence: true,
        interactions: true,
        heartbeatMultiplier: 2,
        eventThrottleMs: 750,
      };
    case "aggregate":
      return {
        presence: false,
        interactions: false,
        heartbeatMultiplier: 2,
        eventThrottleMs: 0,
      };
    case "offline":
      return {
        presence: false,
        interactions: false,
        heartbeatMultiplier: 1,
        eventThrottleMs: 0,
      };
  }
}
